import { ExtractRouteParams } from "@CommonUtils/routes";

export const RouteGetCategories_categoryId_BatchGenerateItems =
  "/categories/:categoryId/batch-generate-items";

export type ParamsGetCategories_categoryId_BatchGenerateItems = ExtractRouteParams<
  typeof RouteGetCategories_categoryId_BatchGenerateItems
>;

export type ResponseGetCategories_categoryId_BatchGenerateItems = BatchGenerateItem[];

export interface BatchGenerateItem {
  createdAt: string;
  storeCode: string;
  pmUpload: UploadStatus;
  ffUpload: UploadStatus;
}

export interface UploadStatus {
  status: "NOT_STARTED" | "IN_PROGRESS" | "UPLOADED" | "FAILED";
  error: string | null;
}
